import { useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { RIGHT_PANEL_WIDTH } from '@components/PropertiesPanel';
import { BUILDER_BAR_HEIGHT } from '@/modules/navigationBar/components/BuilderBar';
import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';

export const useCanvasViewportSetup = () => {
  const theme = useTheme();
  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);

  useEffect(() => {
    const onWindowResize = () => {
      if (window.innerWidth > theme.breakpoints.values.sm) {
        appSvc.setCanvasViewport({
          w: window.innerWidth - RIGHT_PANEL_WIDTH,
          h: window.innerHeight - BUILDER_BAR_HEIGHT,
        });
      } else {
        appSvc.setCanvasViewport({
          w: window.innerWidth,
          h: window.innerHeight,
        });
      }
    };
    window.addEventListener('resize', onWindowResize);
    onWindowResize(); // Set initial viewport size

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, [appSvc, theme.breakpoints.values.sm]);
};
